import styled from 'styled-components';

export const IdentifiedGroupWrapper = styled.div`
  padding: 8px 16px 16px;
  background: #f5f7fb;
  border-radius: 8px;
  margin: 0 40px;

  & + & {
    margin-top: 12px;
  }
`;

export const Title = styled.h3`
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #8f95b2;
  margin: unset;
  margin-bottom: 12px;
  margin-top: 16px;
`;

export const ProductDetailsActionItem = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #1371fe;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;

  cursor: pointer;
`;

export const RightColumn = styled.div`
  grid-column: span 2;
`;
